import { PRODUCT_HANDLER, PRODUCT_TYPES, STAGE } from "../constants";


export const REPEAT_PERSONAL_LOAN_STEPS = [
  "Loan Offer",
  "KYC Verification",
  "Re-Payment Setup",
  "E-Sign",
];

export const stageMapRPL = {
  [STAGE.OFFERS]: "Loan Offers",
  [STAGE.CKYC]: "KYC Verification",
  [STAGE.ADD_ADDRESS]: "KYC Verification",
  [STAGE.DIGI_KYC]: "KYC Verification",
  [STAGE.MANDATE]: "Re-Payment Setup",
  [STAGE.MANDATE_PENNYDROP]: "Re-Payment Setup",
  [STAGE.E_SIGN]: "E-Sign",
  [STAGE.E_SIGN_KFS_INCOMPLETE]: "E-Sign",
};


export const RPL_PROGRESS_MAP = {
  [STAGE.OFFERS]: 20,
  [STAGE.CKYC]: 30,
  [STAGE.ADD_ADDRESS]: 30,
  [STAGE.DIGI_KYC]: 30,
  [STAGE.MANDATE]: 50,
  [STAGE.MANDATE_PENNYDROP]: 50,
  [STAGE.E_SIGN]: 80,
  [STAGE.E_SIGN_KFS_INCOMPLETE]: 80,
  [STAGE.BRE_CPV_TVR]: 100,
  [STAGE.LMS_ONBOARDING]: 100,
};

export const checkForRpl = (data) => data?.sub_product_type === PRODUCT_HANDLER[PRODUCT_TYPES.REPEAT_LOAN];
export const checkForRplProductRoute = (product) => product === PRODUCT_TYPES.REPEAT_LOAN;

const RL_ROUTE_NAMES = {
  OFFERS: "OFFERS",
  IDENTITY_DETAILS: "IDENTITY_DETAILS",
  PERSONAL_DETAILS: "PERSONAL_DETAILS",
  FACE_VERIFICATION: "FACE_VERIFICATION",
  REPAYMENT_SETUP: "REPAYMENT_SETUP",
  REPAYMENT_MODE: "REPAYMENT_MODE",
  REPAYMENT_BANKING: "REPAYMENT_BANKING",
  E_SIGN: "E_SIGN",
  CONDITIONAL_APPROVAL: "CONDITIONAL_APPROVAL",
  DISBURSED: "DISBURSED",
  OFFER_UPDATE: "OFFER_UPDATE",
};
const ROUTE_STAGE_MATCH = {
  [RL_ROUTE_NAMES.OFFERS]: [STAGE.OFFERS],
  [RL_ROUTE_NAMES.IDENTITY_DETAILS]: [STAGE.CKYC],
  [RL_ROUTE_NAMES.PERSONAL_DETAILS]: [STAGE.ADD_ADDRESS],
  [RL_ROUTE_NAMES.FACE_VERIFICATION]: [STAGE.DIGI_KYC],
  [RL_ROUTE_NAMES.REPAYMENT_SETUP]: [STAGE.MANDATE],
  [RL_ROUTE_NAMES.REPAYMENT_MODE]: [STAGE.MANDATE],
  [RL_ROUTE_NAMES.REPAYMENT_BANKING]: [STAGE.MANDATE_PENNYDROP, STAGE.MANDATE],
  [RL_ROUTE_NAMES.E_SIGN]: [STAGE.E_SIGN, STAGE.E_SIGN_KFS_INCOMPLETE],
  [RL_ROUTE_NAMES.CONDITIONAL_APPROVAL]: [
    STAGE.BRE_CPV_TVR,
    STAGE.LMS_ONBOARDING,
    STAGE.DISBURSED
  ],
  [RL_ROUTE_NAMES.DISBURSED]: [STAGE.DISBURSED],
  [RL_ROUTE_NAMES.OFFER_UPDATE]: [STAGE.OFFERS],
};

export const routeBasedProceedDisablityCheck = (pathname, stage) => {
  if (!stage) return true;
  const routeName = pathname
    ?.split("/")
    ?.filter(Boolean)
    ?.pop()
    ?.toUpperCase()
    ?.replaceAll("-", "_");

  const allowedStages = ROUTE_STAGE_MATCH[routeName];
  if (allowedStages?.length) {
    let res = !allowedStages.includes(stage?.toUpperCase());
    return res;
  }

  // Don't want to block for unknown routes, ensuring backward compatibility
  return false;
};

